import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=f2c1a83a&scoped=true&"
import script from "./menuItem.vue?vue&type=script&lang=js&"
export * from "./menuItem.vue?vue&type=script&lang=js&"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=f2c1a83a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c1a83a",
  null
  
)

export default component.exports